import type { AdminWalletTransaction } from '../../../types/models/Wallet';

// Client-side CSV builder for the cross-client ledger export (GET /admin/wallets/transactions).
// Pure functions — the download itself goes through utils/fileDownload.

export const LEDGER_CSV_HEADER = [
  'id',
  'created_at',
  'client_id',
  'client_name',
  'kind',
  'amount',
  'balance_after',
  'reference_type',
  'reference_id',
  'reference_label',
  'description',
  'user_id',
] as const;

/** UTF-8 byte-order mark so Excel opens accented descriptions correctly. */
export const CSV_BOM = '﻿';

/**
 * RFC 4180 field quoting: a field containing a comma, a double quote or a line break is wrapped in
 * double quotes, with embedded quotes doubled. `null`/`undefined` become the empty field.
 */
export function csvField(value: string | number | null | undefined): string {
  if (value === null || value === undefined) {
    return '';
  }
  const s = String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function ledgerRowToCsv(t: AdminWalletTransaction): string {
  return [
    t.id,
    t.created_at,
    t.client_id,
    t.client_name,
    t.kind,
    t.amount,
    t.balance_after,
    t.reference_type,
    t.reference_id,
    t.reference_label,
    t.description,
    t.user_id,
  ]
    .map(csvField)
    .join(',');
}

/** Whole file: BOM + header + one line per row, CRLF-terminated (RFC 4180). */
export function buildLedgerCsv(rows: AdminWalletTransaction[]): string {
  const lines = [LEDGER_CSV_HEADER.join(','), ...rows.map(ledgerRowToCsv)];
  return `${CSV_BOM}${lines.join('\r\n')}\r\n`;
}

export function ledgerCsvFilename(from: string | undefined, to: string | undefined): string {
  return `wallet-ledger_${from ?? 'start'}_${to ?? 'today'}.csv`;
}
